export type SpeechResult = { isFinal: boolean; 0: { transcript: string } };
export type Recognition = {
  lang: string; continuous: boolean; interimResults: boolean;
  onresult: ((event: { resultIndex: number; results: ArrayLike<SpeechResult> }) => void) | null;
  onerror: ((event: { error: string }) => void) | null;
  onend: (() => void) | null;
  onstart: (() => void) | null; onspeechstart: (() => void) | null; onspeechend: (() => void) | null;
  start(): void; stop(): void; abort(): void;
};
export type SpeechHost = { SpeechRecognition?: new () => Recognition; webkitSpeechRecognition?: new () => Recognition };
export function speechConstructor(host: SpeechHost = window as SpeechHost) { return host.SpeechRecognition ?? host.webkitSpeechRecognition; }
export function disposeSpeech(instance: Recognition) {
  instance.onresult = null; instance.onerror = null; instance.onend = null;
  instance.onstart = null; instance.onspeechstart = null; instance.onspeechend = null; instance.abort();
}
export function createSpeechInput(Constructor: new () => Recognition, callbacks: { append(text: string): void; error(message: string): void; end(): void; started(): void; speaking(value: boolean): void; interim(text: string): void }): Recognition {
  const instance = new Constructor();
  instance.lang = 'ja-JP'; instance.continuous = true; instance.interimResults = true;
  instance.onstart = callbacks.started;
  instance.onspeechstart = () => callbacks.speaking(true);
  instance.onspeechend = () => callbacks.speaking(false);
  instance.onresult = event => {
    let finalText = '';
    let interimText = '';
    for (let i = event.resultIndex; i < event.results.length; i++) {
      if (event.results[i].isFinal) finalText += event.results[i][0].transcript;
      else interimText += event.results[i][0].transcript;
    }
    callbacks.interim(interimText);
    if (finalText) callbacks.append(finalText);
  };
  instance.onerror = event => {
    callbacks.error(event.error === 'not-allowed' || event.error === 'service-not-allowed' ? 'マイクの使用が許可されていません。ブラウザの設定かキーボードの音声入力をご利用ください。' : event.error === 'no-speech' ? '声を聞き取れませんでした。もう一度お試しください。' : '音声入力を終了しました。入力済みの文章は残っています。');
    disposeSpeech(instance); callbacks.end();
  };
  instance.onend = callbacks.end;
  return instance;
}
